import axios from 'axios'

export default class EntityUserService {
  static list = (entityId, { parameters, filters }) =>
    axios.get(`/entities/${entityId}/users${filters}`, {
      params: parameters,
      excludeLoader: true,
    })
}
